export default __webpack_public_path__ + "static/media/snapshot.f0462f43.svg";